"use strict";
/*
    Copyright 2019 Dynatrace LLC

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUCHBASE = exports.REDSHIFT = exports.COLDFUSION_IMQ = exports.H2 = exports.CASSANDRA = exports.VERTICA = exports.TERADATA = exports.SYBASE = exports.SQLITE = exports.SQLSERVER = exports.POSTGRESQL = exports.POINTBASE = exports.PERVASIVE = exports.ORACLE = exports.NETEZZA = exports.MARIADB = exports.MYSQL = exports.INTERBASE = exports.INSTANT_DB = exports.INFORMIX = exports.FILEMAKER = exports.DERBY_EMBEDDED = exports.DERBY_CLIENT = exports.DB2 = exports.FIREBIRD = exports.ADABAS = exports.CACHE = exports.ENTERPRISE_DB = exports.FIRST_SQL = exports.INGRES = exports.HANADB = exports.MAXDB = exports.PROGRESS = exports.HSQLDB = exports.CLOUDSCAPE = exports.APACHE_HIVE = void 0;
/**
 * Constants for well known database vendors. May be used in DatabaseInfo.
 */
exports.APACHE_HIVE = "ApacheHive";
exports.CLOUDSCAPE = "Cloudscape";
exports.HSQLDB = "HSQLDB";
exports.PROGRESS = "Progress";
exports.MAXDB = "MaxDB";
exports.HANADB = "HanaDB";
exports.INGRES = "Ingres";
exports.FIRST_SQL = "FirstSQL";
exports.ENTERPRISE_DB = "EnterpriseDB";
exports.CACHE = "Cache";
exports.ADABAS = "Adabas";
exports.FIREBIRD = "Firebird";
exports.DB2 = "DB2";
exports.DERBY_CLIENT = "Derby Client";
exports.DERBY_EMBEDDED = "Derby Embedded";
exports.FILEMAKER = "Filemaker";
exports.INFORMIX = "Informix";
exports.INSTANT_DB = "InstantDb";
exports.INTERBASE = "Interbase";
exports.MYSQL = "MySQL";
exports.MARIADB = "MariaDB";
exports.NETEZZA = "Netezza";
exports.ORACLE = "Oracle";
exports.PERVASIVE = "Pervasive";
exports.POINTBASE = "Pointbase";
exports.POSTGRESQL = "PostgreSQL";
exports.SQLSERVER = "SQL Server";
exports.SQLITE = "sqlite";
exports.SYBASE = "Sybase";
exports.TERADATA = "Teradata";
exports.VERTICA = "Vertica";
exports.CASSANDRA = "Cassandra";
exports.H2 = "H2";
exports.COLDFUSION_IMQ = "ColdFusion IMQ";
exports.REDSHIFT = "Amazon Redshift";
exports.COUCHBASE = "Couchbase";
